<script lang="ts" setup>
const { tabs } = useRfqV2Nav()

const nav = useTemplateRef('nav')

function centerActiveTab() {
  const el = nav.value
  const active = el?.querySelector<HTMLElement>('[data-active="true"]')
  if (!el || !active) {
    return
  }
  el.scrollLeft = active.offsetLeft - (el.clientWidth - active.offsetWidth) / 2
}

onMounted(() => nextTick(centerActiveTab))
watch(() => tabs.value.find(tab => tab.active)?.key, () => nextTick(centerActiveTab))
</script>

<template>
  <nav
    ref="nav"
    aria-label="Request for Quotation progress"
    class="sticky top-14 z-30 flex h-14.5 w-full items-end justify-start gap-10 overflow-x-auto overflow-y-hidden border-b border-default bg-page px-4 md:static md:justify-center md:overflow-x-visible md:overflow-y-visible md:px-0"
  >
    <NuxtLink
      v-for="tab in tabs"
      :key="tab.key"
      :to="tab.to"
      :data-active="tab.active"
      class="-mb-px flex items-center border-b-2 pb-5 transition-colors"
      :class="tab.active ? 'border-accent text-accent' : 'border-transparent text-secondary hover:text-accent'"
    >
      <span class="flex size-5 shrink-0 items-center justify-center">
        <component :is="tab.icon" class="size-3.5" aria-hidden="true" />
      </span>
      <span class="text-xs font-semibold whitespace-nowrap">{{ tab.label }}</span>
    </NuxtLink>
  </nav>
</template>
